import { initReactI18next } from 'react-i18next'
import { createI18nInstance } from './i18n'

const i18nClient = createI18nInstance(initReactI18next)

export default i18nClient
